import { render } from "./Facturatie.vue?vue&type=template&id=b965ea6c"
import script from "./Facturatie.vue?vue&type=script&lang=js"
export * from "./Facturatie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__